import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsCreateArticleRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-create-article',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
	query: ['draftShareId?', 'topicId?'],
};
